import { makeStyles } from '@mui/styles';

const drawerWidth = 240;

export const useStyles = makeStyles(theme => ({
  titulo: {
    textAlign: 'center',
    fontSize: '35px',
    margin: "10px 0px",
    fontWeight: 800
  },
  contenedorHeader:{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    textTransform: 'uppercase',
	},
  contenedorHeader_tipo: {
    fontSize: '27px',
    fontWeight: 800,
  },
  contenedorHeader_monto: {
    fontSize: '22px',
    fontWeight: 600,
  },
}));